/**
 * Price-line / SVG line-style helpers, extracted from Chart.tsx.
 *
 * `priceLineStyleFromName` maps the theme's serialisable style name to
 * lightweight-charts' `LineStyle` enum; `svgDasharrayFromName` is the SVG
 * equivalent for the fib overlay (which draws its own lines).
 */
import { LineStyle } from "lightweight-charts";

const PRICE_LINE_STYLE: Record<string, LineStyle> = {
  solid: LineStyle.Solid,
  dotted: LineStyle.Dotted,
  dashed: LineStyle.Dashed,
  largeDashed: LineStyle.LargeDashed,
  sparseDotted: LineStyle.SparseDotted,
};

export function priceLineStyleFromName(name: string | undefined): LineStyle {
  return PRICE_LINE_STYLE[name ?? "solid"] ?? LineStyle.Solid;
}

const SVG_DASHARRAY: Record<string, string> = {
  solid: "",
  dotted: "2 3",
  dashed: "6 3",
  largeDashed: "10 4",
  sparseDotted: "1 5",
};

export function svgDasharrayFromName(name: string | undefined): string {
  return SVG_DASHARRAY[name ?? "solid"] ?? "";
}

/** Lightweight-charts caps line width at 4 — clamp here so a hand-edited
 *  workspace JSON with `priceLineWidth: 99` doesn't silently render at max. */
export function clampPriceLineWidth(w: unknown): 1 | 2 | 3 | 4 {
  const n = typeof w === "number" && Number.isFinite(w) ? Math.round(w) : 1;
  if (n <= 1) return 1;
  if (n >= 4) return 4;
  return n as 2 | 3;
}
